import { SxProps, Theme } from "@mui/material/styles";
import { gris1 } from "../../../../theme";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      maxWidth: "880px",
      margin: "48px auto",
      "& > div": {
        display: "flex",
        alignItems: "flex-end",
      },
      "& h2": {
        fontSize: 32,
      },
    },
    "& .inputFormName": {
      "& > div:first-of-type": {
        marginRight: "4px",
      },
      "& > div:last-of-type": {
        marginLeft: "4px",
      },
    },
    "& .formContact": {
      maxWidth: 700,
      "& > div": {
        marginBottom: 2,
      },
      "& .MuiInputBase-root": {
        background: "white",
      },
    },
    "& .subtitle": {
      "& > h2": {
        fontSize: 18,
        padding: 0,
        color: gris1,
      },
    },
  },
];

export default styles;
